import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';

export interface InboxMessage {
  id: number;
  title: string;
  subject: string;
  content: string;
  channel: 'sms' | 'email' | 'push';
  date: string;
  status: string;
  severity: string;
  is_dismissed: boolean;
  is_system: boolean;
}

export interface InboxResponse {
  messages: InboxMessage[];
}

export const ParentInboxApi = createApi({
  reducerPath: 'ParentInboxApi',
  baseQuery,
  tagTypes: ['Inbox'],
  endpoints: builder => ({
    getInboxMessages: builder.query<InboxResponse, void>({
      query: () => `/parent/inbox`,
      providesTags: ['Inbox'],
    }),
    dismissMessage: builder.mutation<any, number>({
      query: messageId => ({
        url: `/noticeboard/notices/${messageId}/dismiss`,
        method: 'POST',
      }),
      invalidatesTags: ['Inbox'],
    }),
    dismissAllMessages: builder.mutation<void, void>({
      query: () => ({
        url: '/noticeboard/notices/dismiss-all',
        method: 'POST',
      }),
      invalidatesTags: ['Inbox'],
    }),
  }),
});

export const {
  useGetInboxMessagesQuery,
  useDismissMessageMutation,
  useDismissAllMessagesMutation,
} = ParentInboxApi;
